import { render, staticRenderFns } from "./AddressFormModal.vue?vue&type=template&id=6770e378&scoped=true"
import script from "./AddressFormModal.vue?vue&type=script&lang=js"
export * from "./AddressFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770e378",
  null
  
)

export default component.exports